import {animate, style, transition, trigger} from '@angular/animations';

export const fadeInAnimation = trigger('fadeIn', [
  transition(':enter', [
    style({opacity: 0}),
    animate('0.3s cubic-bezier(0.35, 0, 0.25, 1)')
  ]),
]);

export const popUpInAnimation = trigger('popUpIn', [
  transition(':enter', [
    style({opacity: 0, transform: 'scale(50%)'}),
    animate('0.3s cubic-bezier(0.35, 0, 0.25, 1)')
  ]),
]);
